import React, { useState, useEffect } from 'react';
import { setDataSession, getDataSession, removeDataSession } from 'views/Utils/Common';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services'
import SLUGS from 'resources/slugs';
import Swal from 'sweetalert2';

const AuthTienda = ({ history, tienda, code, sucursal_id, isNoLogin }) => {
    let [error, setError] = useState(['']);
    let [success, setSuccess] = useState(['']);
    const sucursalAuth = getDataSession('sucursalAuth');

    const GetTienda = () => {
        switch (tienda) {
            case 'MERCADOLIBRE': return 'Mercado Libre';
            case 'TIENDANUBE':
            default: return 'Tienda Nube';
        }
    }

    useEffect(() => { 
        const saveCode = () => {
            if (!code) {
                setError('Error al obtener el código de acceso a tu tienda\r\n Intentelo mas tarde');
                return;
            }

            if (isNoLogin) {
                setDataSession("authTienda", tienda);
                setDataSession("authCode", code);
                history.push(`${SLUGS.login}`);
                Swal.fire('Info', 'Para proseguir con la configuracion, favor de iniciar sesíon o registrarse', 'info');
                return;
            }

            if (!sucursal_id) {
                if (!sucursalAuth) {
                    setDataSession("authTienda", tienda);
                    setDataSession("authCode", code);
                    history.push(`${SLUGS.dashboard}`);
                    return;
                }

                setError('Error al obtener el identificador de la sucursal\r\n Intentelo mas tarde');
                return;
            }

            fetchConToken(`ConfiguracionesSucursales/ObtenerToken?Code=${code}&sucursal_id=${sucursal_id}&tienda=${tienda}`).then((response) => {
                setError('');
                if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    setError(response.mensajes[0] + "\r\n Intentelo mas tarde");
                    return;
                }

                setSuccess('La cambios se han guardado correctamente. \r\n Puede cerrar la ventana');
                removeDataSession('sucursalMercadoLibre');
                removeDataSession('sucursalTiendaNube');
                removeDataSession('sucursalAuth');
                removeDataSession('authTienda');
                removeDataSession('authCode');
            }).catch(alertService.error);
        }
        saveCode(); 
    }, [code, history, isNoLogin, sucursalAuth, sucursal_id, tienda]);

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12' style={{ display: 'grid' }}>
                        <div className='card mb-3 '>
                            <div className='card-body text-start'>
                                <div className='card-title text-center'>
                                    <h5>Confirmando su autorizacion de</h5>
                                    <h2>{GetTienda()}</h2>
                                </div>
                                <div className='row'><div className='col-md-12 text-center'>{code}</div></div>
                            </div>
                            <div className='text-center'>
                                <h3 style={{ color: 'red' }}>{error}</h3>
                                <h3 style={{ color: 'blue' }}>{success}</h3>
                                {error || success ? (<br />) : ('')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { AuthTienda };